module.exports = __webpack_public_path__ + "img/icon-32-ic-plug.03140332.svg";